import type { AppDataTableColumn } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { AppBadgeForAno } from '@9b3kuq5phwuk4txw/kiban-react-ui'

/** 派生案件の型 */
export type DerivedProject = {
  ano: string | null
  salesforce_customer_name: string | null
  salesforce_project_name: string | null
}

/** 派生案件テーブルのカラム定義 */
export const derivedProjectColumns: AppDataTableColumn<DerivedProject>[] = [
  {
    key: 'ano',
    label: 'ANO',
    accessor: (row) => row.ano || '-',
    sortable: false,
    render: (row) => <AppBadgeForAno ano={row.ano} />,
  },
  {
    key: 'salesforce_customer_name',
    label: '取引先',
    accessor: (row) => row.salesforce_customer_name || '-',
    sortable: false,
  },
  {
    key: 'salesforce_project_name',
    label: '案件名',
    accessor: (row) => row.salesforce_project_name || '-',
    sortable: false,
  },
]
